import React from "react";
import { Box, Typography } from "@mui/material";
import MenuList from "./MenuList";
import MenuAccordion from "./MenuAccordion";
import MenuEntry from "./MenuEntry";

const MenuSection = ({ section, uri, pathname, closeMobileMenu }) => {
  const renderEntry = (entry, index) => {
    switch (entry.type) {
      case "accordion":
        return (
          <MenuAccordion
            key={`accordion-${entry.title}-${index}`}
            accordionEntry={entry}
            browserUri={uri}
            pathname={pathname}
            onMobileClose={closeMobileMenu}
          />
        );
      case "list":
        return (
          <MenuList
            key={`list-${entry.title}-${index}`}
            listEntry={entry}
            browserUri={uri}
            onMobileClose={closeMobileMenu}
          />
        );
      case "link":
      default:
        return (
          <MenuEntry
            key={`link-${entry.title}-${index}`}
            entry={entry}
            browserUri={uri}
            paddingLeft={20}
            onMobileClose={closeMobileMenu}
          />
        );
    }
  };

  if (!section.title) {
    return <Box className="menu-section no-title">{section.entries?.map(renderEntry)}</Box>;
  }

  return (
    <Box className="menu-section with-title">
      <Typography variant="subtitle2" className="section-title">
        {section.title}
      </Typography>

      <Box className="section-content">
        <Box>{section.entries?.map(renderEntry)}</Box>
      </Box>
    </Box>
  );
};

export default MenuSection;